import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

export const CategoryButton = ({
  checked,
  className,
  id,
  labelText,
  ...rest
}) => (
  <div className={classNames(styles.categoryFilter, className)}>
    <input
      checked={checked}
      className={styles.input}
      id={id}
      type="checkbox"
      {...rest}
    />
    <label
      className={classNames('button', {
        secondary: !checked,
      })}
      htmlFor={id}
    >
      {labelText}
    </label>
  </div>
)

CategoryButton.displayName = 'CategoryButton'

CategoryButton.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.any,
  onChange: PropTypes.func,
}
